export const HR_LISTS_EN = {
    // Refusals of the row edits and the person's details.
    "gov_sa.gosi.rates.empty": "No contribution rates",
    "gov_sa.gosi.rates.empty.description": "One dated row per scheme and branch appears here; payroll computes from a row only once it is confirmed.",
    "gov_sa.gosi.readings.empty": "No readings to set",
    "gov_sa.gosi.readings.empty.description": "Where the law allows two readings, the setting the rules read appears here with the adopted default.",
    "gov_sa.gosi.worklist.empty": "Nothing to tell GOSI",
    "gov_sa.gosi.worklist.empty.description": "Each registration, wage change or exclusion the establishment must report appears here once, with its due day.",
    "gov_sa.mudad.advances.empty": "No advance files",
    "gov_sa.mudad.advances.empty.description": "Each advance payroll pays appears here with its own WPS file, apart from the run's.",
    "gov_sa.mudad.banks.empty": "No approved banks",
    "gov_sa.mudad.banks.empty.description": "The banks this workspace pays through appear here; while any is approved, a line to a bank not listed is refused.",
    "gov_sa.mudad.compliance.empty": "No months yet",
    "gov_sa.mudad.compliance.empty.description": "Each month's ratio appears here once Mudad's status reports on its WPS files are read.",
    "gov_sa.mudad.establishments.empty": "No establishments yet",
    "gov_sa.mudad.establishments.empty.description": "Each establishment appears here with what GOSI and wage protection ask of it.",
    "gov_sa.mudad.layouts.empty": "No file layouts",
    "gov_sa.mudad.layouts.empty.description": "This product's documented CSV and each bank layout added as data appear here, to confirm before go-live.",
    "gov_sa.muqeem.residences.empty": "No residence permits",
    "gov_sa.muqeem.residences.empty.description": "Every non-citizen's residence permit appears here with its number and expiry.",
    "gov_sa.muqeem.worklist.empty": "No visas to handle",
    "gov_sa.muqeem.worklist.empty.description": "An exit/re-entry or final-exit visa, or a sponsorship transfer, appears here once for each leave, end of service or transfer.",
    "gov_sa.nitaqat.bands.empty": "No bands recorded",
    "gov_sa.nitaqat.bands.empty.description": "The ratio each band starts at appears here from its day, as the authority's table gives it.",
    "gov_sa.nitaqat.minimum_wages.empty": "No minimum wage recorded",
    "gov_sa.nitaqat.minimum_wages.empty.description": "The wage a citizen must be registered at to count appears here from its day, once somebody else confirms it.",
    "gov_sa.nitaqat.ratio.empty": "No ratio computed yet",
    "gov_sa.nitaqat.ratio.empty.description": "The Saudization ratio appears here each time it moves, newest first, with its band.",
    "gov_sa.qiwa.worklist.empty": "Nothing to do on Qiwa",
    "gov_sa.qiwa.worklist.empty.description": "Each contract to attest or update, relation to close, hire to verify or service to transfer appears here once.",
    // HR UX review 2026-10-04, high-severity findings.
    "gov_sa.gosi.case_exclusion.alert": "Exclude the employee on the GOSI portal by {due_on}, then record its reference here — it does not happen by itself",
    "gov_sa.gosi.case_exclusion.title": "Exclusion from GOSI",
    "gov_sa.gosi.rates.adopt.consequence": "Rows proposed for confirmation: {proposed}. Unconfirmed rows withdrawn to make room: {withdrawn} — listed below. A confirmed row is not touched.",
    "gov_sa.gosi.rates.adopt.nothing": "Nothing to adopt: every day the pack covers already has a confirmed or an adopted row.",
    "gov_sa.gosi.rates.adopt.withdraws": "Unconfirmed rows it will withdraw",
    "gov_sa.gosi.rates.pack.consequence": "Rows added, unconfirmed: {inserted}. Rows already present and kept as they are: {skipped}. No row is replaced.",
    "gov_sa.gosi.rates.pack.nothing": "Every row of the pack is already here: loading it would add nothing.",
    "gov_sa.gosi.reconcile.open_item": "Open the item on the worklist",
    "gov_sa.gosi.settings.maternity_leave_types.choose": "Each leave of these types granted is a compensation notice to GOSI.",
    "gov_sa.mudad.establishment.bank.help": "Chosen from the approved banks; its code is filled for you, and a whole IBAN chooses it.",
    "gov_sa.mudad.establishment.iban_checksum": "The IBAN fails its check digits: a digit is wrong.",
    "gov_sa.muqeem.case_final_exit.alert": "Issue the final exit visa on Muqeem, then record its number here — it does not happen by itself",
    "gov_sa.muqeem.case_final_exit.title": "Final exit on Muqeem",
    "gov_sa.muqeem.settings.residence_types.help": "A renewed document of one of these types moves the person's residence and its expiry.",
    "gov_sa.muqeem.settings.types_unread": "The document types could not be read: only the types already set are offered.",
    "gov_sa.qiwa.case_relation.alert": "End the relation on Qiwa from {effective_on}, then record its reference here — it does not happen by itself",
    "gov_sa.qiwa.case_relation.title": "Relation on Qiwa",
    // HR record pages (grievance, leave request, payroll run, contract, decision, establishment), 2026-10-04.
    "gov_sa.establishment.action.change": "Change",
    "gov_sa.establishment.col.kind": "Kind",
    "gov_sa.establishment.open_them": "Open them",
    "gov_sa.gosi.establishment_number.help": "Digits, as GOSI writes the establishment's subscription. ⚠ Its length is to confirm.",
    "gov_sa.gosi.establishment_number.title": "GOSI subscription number",
    "gov_sa.gosi.establishment_state.col.ready": "To report",
    "gov_sa.gosi.establishment_state.ready.none": "Nothing to report",
    "gov_sa.gosi.establishment_state.ready.to_report": "To report",
    "gov_sa.gosi.establishment_state.ready_words": "{to_report} to report",
    "gov_sa.gosi.establishment_state.title": "GOSI",
    "gov_sa.gosi.settings.col.exclude": "Exclude within",
    "gov_sa.gosi.settings.col.new_scheme": "The new scheme from",
    "gov_sa.gosi.settings.col.register": "Register within",
    "gov_sa.gosi.settings.exclude_words": "{exclude_within_days:days} of the last day",
    "gov_sa.gosi.settings.field.exclude": "Exclude within (days)",
    "gov_sa.gosi.settings.field.register": "Register within (days)",
    "gov_sa.gosi.settings.register_words": "{register_within_days:days} of joining",
    "gov_sa.mudad.establishment_wps.col.top_reason_most": "Most rejected for",
    "gov_sa.mudad.establishment_wps.title_short": "Wage protection — {month:month}",
    "gov_sa.mudad.establishment_wps_settings.title": "Wage protection",
    "gov_sa.mudad.establishments.lede_record": "Each establishment with its identity, its standing at every authority and its settings, on its own page.",
    "gov_sa.mudad.establishments.title_record": "Establishments",
    "gov_sa.mudad.overview.alert.open_run": "Open the payroll run",
    "gov_sa.mudad.overview.col.months": "Months",
    "gov_sa.mudad.overview.status.wps": "Wage protection · {wps_month:month}",
    "gov_sa.mudad.overview.status.wps_none": "Wage protection",
    "gov_sa.mudad.overview.status.wps_words": "{wps_standing} · {wps_ratio}% of {wps_threshold}%",
    "gov_sa.mudad.overview.tab.settings": "Settings",
    "gov_sa.mudad.overview.tab.wps": "Wage protection",
    "gov_sa.mudad.overview.tab.wps.month_words": "{month:month}",
    "gov_sa.mudad.overview.tab.wps.note": "The threshold is a setting — ⚠ confirm the one your establishment is held to.",
    "gov_sa.mudad.overview.tab.wps.table": "Each month's paid ratio from Mudad's reports",
    "gov_sa.mudad.payroll_run.alert": "After the payment the wage protection file is written, and uploaded to Mudad within {upload_window_days} days of the pay day ⚠",
    "gov_sa.mudad.payroll_run.col.made": "Written",
    "gov_sa.mudad.payroll_run.col.window": "Upload window",
    "gov_sa.mudad.payroll_run.col.window.template": "{upload_window_days} days from the pay day ⚠",
    "gov_sa.mudad.payroll_run.made.free_transfer": "past the window: transfer without consent",
    "gov_sa.mudad.payroll_run.made.late": "past the upload window",
    "gov_sa.mudad.payroll_run.made.no_pay_date": "once the payment is recorded",
    "gov_sa.mudad.payroll_run.made.on_time": "written; the upload window is running",
    "gov_sa.mudad.payroll_run.made.services_frozen": "past the window: services frozen",
    "gov_sa.mudad.payroll_run.made.uploaded": "written and uploaded",
    "gov_sa.mudad.payroll_run.open": "Open in Mudad",
    "gov_sa.mudad.payroll_run.title": "Wage protection",
    "gov_sa.mudad.run.col.run_id": "Payroll run",
    "gov_sa.mudad.run.col.run_id.template": "Open the run",
    "gov_sa.mudad.settings.col.fine": "Fine per worker ⚠",
    "gov_sa.mudad.settings.col.freeze": "Services frozen after",
    "gov_sa.mudad.settings.col.threshold": "Compliance threshold ⚠",
    "gov_sa.mudad.settings.col.transfer": "Transfer of services without consent after",
    "gov_sa.mudad.settings.col.upload_window": "Upload the file within ⚠",
    "gov_sa.mudad.settings.fine_words": "{fine_per_worker:money}",
    "gov_sa.mudad.settings.layout": "Layout",
    "gov_sa.mudad.settings.layout.default": "This product's documented layout",
    "gov_sa.mudad.settings.note": "Every figure marked ⚠ is to confirm with the authority before go-live.",
    "gov_sa.mudad.settings.threshold_words": "{compliance_threshold}%",
    "gov_sa.mudad.settings.upload_window_words": "{upload_window_days:days} from the pay day",
    "gov_sa.muqeem.col.warning_days": "Warning window",
    "gov_sa.muqeem.establishment.col.exit_reentry": "Exit and re-entry visas in force",
    "gov_sa.muqeem.establishment.col.expired": "Expired",
    "gov_sa.muqeem.establishment.col.expiring": "Expiring soon",
    "gov_sa.muqeem.establishment.col.transfers": "Transfers of services under way",
    "gov_sa.muqeem.establishment.expiring_words": "{expiring} within {warning_days:days}",
    "gov_sa.muqeem.establishment.title": "Muqeem",
    "gov_sa.muqeem.establishment_expiring.alert": "Residences expiring within {warning_days}: {count}",
    "gov_sa.muqeem.establishment_expiring.title": "Residences expiring",
    "gov_sa.muqeem.establishment_tab.empty": "No residence is known yet.",
    "gov_sa.muqeem.request_visa.alert": "The exit / re-entry visa for this leave in Muqeem: {status}",
    "gov_sa.muqeem.request_visa.col.reference": "Visa number",
    "gov_sa.muqeem.request_visa.title": "Exit / re-entry visa",
    "gov_sa.muqeem.residence_type.iqama": "Iqama",
    "gov_sa.muqeem.residence_type.residence": "Residence",
    "gov_sa.muqeem.residence_type.residence_permit": "Residence permit",
    "gov_sa.muqeem.settings.col.types": "Residence types followed",
    "gov_sa.muqeem.settings.col.warning": "Warn before a residence expires",
    "gov_sa.muqeem.settings.field.types": "Document types that are a residence",
    "gov_sa.muqeem.settings.field.types.help": "The documents module's type keys, separated by commas.",
    "gov_sa.muqeem.settings.field.warning": "Warn before a residence expires (days)",
    "gov_sa.nitaqat.establishment.counted_words": "{saudis_counted} · non-citizens {non_saudis}",
    "gov_sa.nitaqat.establishment.next_band_words": "{next_band} from {next_min_ratio}%",
    "gov_sa.nitaqat.establishment.ratio_words": "{ratio}%",
    "gov_sa.nitaqat.establishment_state.title": "Nitaqat",
    "gov_sa.nitaqat.establishment_state.words": "{band} · {ratio}%",
    "gov_sa.nitaqat.establishment_tab.empty": "No ratio has been computed yet.",
    "gov_sa.nitaqat.settings.col.margin": "Warn this close to a band's floor",
    "gov_sa.nitaqat.settings.col.thresholds": "The minimum wage and the band floors",
    "gov_sa.nitaqat.settings.field.margin": "Warn this close to a band's floor (points)",
    "gov_sa.nitaqat.settings.margin_words": "{margin} points",
    "gov_sa.nitaqat.settings.thresholds.confirmed": "Confirmed, on their own screens ⚠",
    "gov_sa.nitaqat.settings.thresholds.not_configured": "None in force yet — set them on their own screens ⚠",
    "gov_sa.nitaqat.settings.thresholds.unconfirmed": "Awaiting confirmation on their own screens ⚠",
    "gov_sa.qiwa.establishment.title": "Qiwa",
    "gov_sa.qiwa.establishment_channel.col.connected": "The channel",
    "gov_sa.qiwa.establishment_channel.connected.false": "The channel is not connected",
    "gov_sa.qiwa.establishment_channel.connected.true": "The channel is connected",
    "gov_sa.qiwa.establishment_number.help": "As the labour platform writes it, as 1-2345678. Until it is entered, the deployment's setting is used.",
    "gov_sa.qiwa.establishment_number.title": "Qiwa establishment number",
    "gov_sa.qiwa.establishment_tab.empty": "Nothing is waiting on Qiwa.",
    "gov_sa.qiwa.establishment_unattested.alert": "Contracts not attested on Qiwa: {count}",
    "gov_sa.qiwa.establishment_unattested.title": "Contracts not attested on Qiwa",
    "screen.mudad.establishment_record.title": "Establishment",
    "unit.employees.few": "{n} employees",
    "unit.employees.many": "{n} employees",
    "unit.employees.one": "one employee",
    "unit.employees.other": "{n} employees",
    "unit.employees.two": "two employees",
    "unit.employees.zero": "no employees",
    "value.decision.none": "Not decided yet",
    "value.moved.joined": "Joined",
    "value.moved.left": "Left",
    // The HR screens review (2026-10-07): record pages' trail words, and the keys their new columns, alerts and tiles name.
    "screen.mudad.establishment.title": "Establishment (WPS)",
    "screen.mudad.run.title": "Payroll run (WPS)",
};
export const HR_LISTS_AR = {
    // Refusals of the row edits and the person's details.
    "gov_sa.gosi.rates.empty": "لا نسب اشتراك",
    "gov_sa.gosi.rates.empty.description": "يظهر هنا صفّ مؤرّخ لكل نظام وفرع؛ ولا تحسب الرواتب منه حتى يُعتمد.",
    "gov_sa.gosi.readings.empty": "لا قراءات لضبطها",
    "gov_sa.gosi.readings.empty.description": "حيث يحتمل النظام قراءتين، يظهر هنا الإعداد المطبَّق في الحساب مع القيمة المعتمدة.",
    "gov_sa.gosi.worklist.empty": "لا شيء لإبلاغ التأمينات به",
    "gov_sa.gosi.worklist.empty.description": "يظهر هنا مرة واحدة كل تسجيل أو تعديل أجر أو استبعاد يجب أن تبلّغ به المنشأة التأمينات الاجتماعية، مع موعده.",
    "gov_sa.mudad.advances.empty": "لا ملفات سُلف",
    "gov_sa.mudad.advances.empty.description": "تظهر هنا كل سلفة تصرفها الرواتب بملف حماية أجور خاص بها، منفصل عن ملف المسيّر.",
    "gov_sa.mudad.banks.empty": "لا بنوك معتمدة",
    "gov_sa.mudad.banks.empty.description": "تظهر هنا البنوك التي تصرف عبرها مساحة العمل؛ وما دام فيها بنك معتمد يُرفض السطر الموجّه لبنك غير مدرج.",
    "gov_sa.mudad.compliance.empty": "لا أشهر بعد",
    "gov_sa.mudad.compliance.empty.description": "تظهر هنا نسبة كل شهر متى قُرئت تقارير حالة مُدد عن ملفات حماية الأجور.",
    "gov_sa.mudad.establishments.empty": "لا منشآت بعد",
    "gov_sa.mudad.establishments.empty.description": "تظهر هنا كل منشأة وما تطلبه منها التأمينات الاجتماعية وحماية الأجور.",
    "gov_sa.mudad.layouts.empty": "لا قوالب ملفات",
    "gov_sa.mudad.layouts.empty.description": "يظهر هنا ملف CSV الموثّق وكل قالب بنك يُضاف كبيانات، لمطابقته قبل التشغيل.",
    "gov_sa.muqeem.residences.empty": "لا إقامات",
    "gov_sa.muqeem.residences.empty.description": "تظهر هنا إقامة كل غير مواطن برقمها وتاريخ انتهائها.",
    "gov_sa.muqeem.worklist.empty": "لا تأشيرات للإنجاز",
    "gov_sa.muqeem.worklist.empty.description": "تظهر هنا تأشيرة الخروج والعودة أو الخروج النهائي أو نقل الخدمات، مرة لكل إجازة أو انتهاء خدمة أو نقل.",
    "gov_sa.nitaqat.bands.empty": "لا نطاقات مسجّلة",
    "gov_sa.nitaqat.bands.empty.description": "تظهر هنا النسبة التي يبدأ عندها كل نطاق، من تاريخه، كما يعطيها جدول الجهة.",
    "gov_sa.nitaqat.minimum_wages.empty": "لا حدّ أدنى للأجر مسجَّل",
    "gov_sa.nitaqat.minimum_wages.empty.description": "يظهر هنا الأجر الذي يجب أن يُسجَّل به المواطن ليُحتسب، من تاريخه، متى أكّده شخص آخر.",
    "gov_sa.nitaqat.ratio.empty": "لم تُحسب النسبة بعد",
    "gov_sa.nitaqat.ratio.empty.description": "تظهر هنا نسبة التوطين كلما تحرّكت، الأحدث أولاً، مع النطاق.",
    "gov_sa.qiwa.worklist.empty": "لا مهام في قوى",
    "gov_sa.qiwa.worklist.empty.description": "يظهر هنا مرة واحدة كل عقد يُوثَّق أو يُحدَّث، وكل علاقة تُنهى، وكل موظّف جديد يُتحقَّق منه، وكل خدمة تُنقل.",
    // HR UX review 2026-10-04, high-severity findings.
    "gov_sa.gosi.case_exclusion.alert": "استبعد الموظّف في بوابة التأمينات قبل {due_on}، ثم سجّل مرجعه هنا — لا يتمّ تلقائياً",
    "gov_sa.gosi.case_exclusion.title": "الاستبعاد من التأمينات",
    "gov_sa.gosi.rates.adopt.consequence": "صفوف ستُقترح للتأكيد: {proposed}. صفوف غير مؤكّدة ستُسحب ليحلّ المقترح محلّها: {withdrawn} — مبيّنة أدناه. لا يُمسّ أي صف مؤكَّد.",
    "gov_sa.gosi.rates.adopt.nothing": "لا شيء للاعتماد: كل يوم تغطيه الحزمة له صف مؤكَّد أو معتمد.",
    "gov_sa.gosi.rates.adopt.withdraws": "صفوف غير مؤكّدة ستُسحب",
    "gov_sa.gosi.rates.pack.consequence": "صفوف ستُضاف غير مؤكّدة: {inserted}. صفوف موجودة تبقى كما هي: {skipped}. لا يُستبدل أي صف.",
    "gov_sa.gosi.rates.pack.nothing": "كل صفوف الحزمة موجودة: تحميلها لن يضيف شيئاً.",
    "gov_sa.gosi.reconcile.open_item": "افتح البند في قائمة العمل",
    "gov_sa.gosi.settings.maternity_leave_types.choose": "كل إجازة تُعتمد من هذه الأنواع تُنشئ إشعار تعويض للتأمينات.",
    "gov_sa.mudad.establishment.bank.help": "يُختار من البنوك المعتمدة ويُملأ رمزه تلقائياً، والآيبان المكتمل يختاره بنفسه.",
    "gov_sa.mudad.establishment.iban_checksum": "الآيبان لا يجتاز خانتي التحقق: أحد أرقامه خاطئ.",
    "gov_sa.muqeem.case_final_exit.alert": "أصدر تأشيرة الخروج النهائي في مقيم، ثم سجّل رقمها هنا — لا يتمّ تلقائياً",
    "gov_sa.muqeem.case_final_exit.title": "الخروج النهائي في مقيم",
    "gov_sa.muqeem.settings.residence_types.help": "تجديد وثيقة من هذه الأنواع ينقل إقامة الموظّف وتاريخ انتهائها.",
    "gov_sa.muqeem.settings.types_unread": "تعذّرت قراءة أنواع الوثائق: تُعرض الأنواع المحدّدة سابقاً فقط.",
    "gov_sa.qiwa.case_relation.alert": "أنهِ العلاقة في قوى اعتباراً من {effective_on}، ثم سجّل مرجعها هنا — لا يتمّ تلقائياً",
    "gov_sa.qiwa.case_relation.title": "العلاقة التعاقدية في قوى",
    // HR record pages (grievance, leave request, payroll run, contract, decision, establishment), 2026-10-04.
    "gov_sa.establishment.action.change": "تعديل",
    "gov_sa.establishment.col.kind": "النوع",
    "gov_sa.establishment.open_them": "افتحها",
    "gov_sa.gosi.establishment_number.help": "أرقام كما تكتبها التأمينات لاشتراك المنشأة. ⚠ يُؤكَّد طوله.",
    "gov_sa.gosi.establishment_number.title": "رقم الاشتراك في التأمينات",
    "gov_sa.gosi.establishment_state.col.ready": "للإبلاغ",
    "gov_sa.gosi.establishment_state.ready.none": "لا شيء للإبلاغ",
    "gov_sa.gosi.establishment_state.ready.to_report": "للإبلاغ",
    "gov_sa.gosi.establishment_state.ready_words": "{to_report} للإبلاغ",
    "gov_sa.gosi.establishment_state.title": "التأمينات",
    "gov_sa.gosi.settings.col.exclude": "الاستبعاد خلال",
    "gov_sa.gosi.settings.col.new_scheme": "النظام الجديد من",
    "gov_sa.gosi.settings.col.register": "التسجيل خلال",
    "gov_sa.gosi.settings.exclude_words": "{exclude_within_days:days} من آخر يوم",
    "gov_sa.gosi.settings.field.exclude": "الاستبعاد خلال (أيام)",
    "gov_sa.gosi.settings.field.register": "التسجيل خلال (أيام)",
    "gov_sa.gosi.settings.register_words": "{register_within_days:days} من المباشرة",
    "gov_sa.mudad.establishment_wps.col.top_reason_most": "أكثر أسباب الرفض",
    "gov_sa.mudad.establishment_wps.title_short": "حماية الأجور — {month:month}",
    "gov_sa.mudad.establishment_wps_settings.title": "حماية الأجور",
    "gov_sa.mudad.establishments.lede_record": "كل منشأة بهويتها ووضعها عند كل جهة وإعداداتها، في صفحتها.",
    "gov_sa.mudad.establishments.title_record": "المنشآت",
    "gov_sa.mudad.overview.alert.open_run": "افتح المسيّر",
    "gov_sa.mudad.overview.col.months": "الأشهر",
    "gov_sa.mudad.overview.status.wps": "حماية الأجور · {wps_month:month}",
    "gov_sa.mudad.overview.status.wps_none": "حماية الأجور",
    "gov_sa.mudad.overview.status.wps_words": "{wps_standing} · {wps_ratio}% من {wps_threshold}%",
    "gov_sa.mudad.overview.tab.settings": "الإعدادات",
    "gov_sa.mudad.overview.tab.wps": "حماية الأجور",
    "gov_sa.mudad.overview.tab.wps.month_words": "{month:month}",
    "gov_sa.mudad.overview.tab.wps.note": "الحد إعداد — ⚠ أكّد الحد المطلوب من منشأتك.",
    "gov_sa.mudad.overview.tab.wps.table": "نسبة المصروف في كل شهر من تقارير مُدد",
    "gov_sa.mudad.payroll_run.alert": "بعد الصرف يُنشأ ملف حماية الأجور، ويُرفع إلى مُدد خلال {upload_window_days} يوماً من يوم الصرف ⚠",
    "gov_sa.mudad.payroll_run.col.made": "يُنشأ",
    "gov_sa.mudad.payroll_run.col.window": "مهلة الرفع",
    "gov_sa.mudad.payroll_run.col.window.template": "{upload_window_days} يوماً من يوم الصرف ⚠",
    "gov_sa.mudad.payroll_run.made.free_transfer": "تجاوز المهلة: نقل الخدمات دون موافقة",
    "gov_sa.mudad.payroll_run.made.late": "تجاوز مهلة الرفع",
    "gov_sa.mudad.payroll_run.made.no_pay_date": "بعد تسجيل الصرف",
    "gov_sa.mudad.payroll_run.made.on_time": "بعد الصرف، والمهلة جارية",
    "gov_sa.mudad.payroll_run.made.services_frozen": "تجاوز المهلة: إيقاف الخدمات",
    "gov_sa.mudad.payroll_run.made.uploaded": "أُنشئ ورُفع",
    "gov_sa.mudad.payroll_run.open": "افتح في مُدد",
    "gov_sa.mudad.payroll_run.title": "حماية الأجور",
    "gov_sa.mudad.run.col.run_id": "المسيّر",
    "gov_sa.mudad.run.col.run_id.template": "افتح المسيّر",
    "gov_sa.mudad.settings.col.fine": "الغرامة لكل عامل ⚠",
    "gov_sa.mudad.settings.col.freeze": "إيقاف الخدمات بعد",
    "gov_sa.mudad.settings.col.threshold": "حد الالتزام ⚠",
    "gov_sa.mudad.settings.col.transfer": "نقل الخدمات دون موافقة بعد",
    "gov_sa.mudad.settings.col.upload_window": "مهلة رفع الملف ⚠",
    "gov_sa.mudad.settings.fine_words": "{fine_per_worker:money}",
    "gov_sa.mudad.settings.layout": "القالب",
    "gov_sa.mudad.settings.layout.default": "القالب الموثَّق في النظام",
    "gov_sa.mudad.settings.note": "كل رقم معلَّم ⚠ يُؤكَّد مع الجهة قبل التشغيل.",
    "gov_sa.mudad.settings.threshold_words": "{compliance_threshold}%",
    "gov_sa.mudad.settings.upload_window_words": "{upload_window_days:days} من يوم الصرف",
    "gov_sa.muqeem.col.warning_days": "مهلة التنبيه",
    "gov_sa.muqeem.establishment.col.exit_reentry": "تأشيرات خروج وعودة قائمة",
    "gov_sa.muqeem.establishment.col.expired": "منتهية",
    "gov_sa.muqeem.establishment.col.expiring": "تنتهي قريباً",
    "gov_sa.muqeem.establishment.col.transfers": "نقل خدمات قيد الإجراء",
    "gov_sa.muqeem.establishment.expiring_words": "{expiring} خلال {warning_days:days}",
    "gov_sa.muqeem.establishment.title": "مقيم",
    "gov_sa.muqeem.establishment_expiring.alert": "إقامات تنتهي خلال {warning_days}: {count}",
    "gov_sa.muqeem.establishment_expiring.title": "إقامات تنتهي قريباً",
    "gov_sa.muqeem.establishment_tab.empty": "لا إقامة معروفة بعد.",
    "gov_sa.muqeem.request_visa.alert": "تأشيرة الخروج والعودة لهذه الإجازة في مقيم: {status}",
    "gov_sa.muqeem.request_visa.col.reference": "رقم التأشيرة",
    "gov_sa.muqeem.request_visa.title": "تأشيرة الخروج والعودة",
    "gov_sa.muqeem.residence_type.iqama": "إقامة",
    "gov_sa.muqeem.residence_type.residence": "إقامة",
    "gov_sa.muqeem.residence_type.residence_permit": "تصريح إقامة",
    "gov_sa.muqeem.settings.col.types": "أنواع الإقامة المتابَعة",
    "gov_sa.muqeem.settings.col.warning": "التنبيه قبل انتهاء الإقامة",
    "gov_sa.muqeem.settings.field.types": "أنواع المستندات التي تُعدّ إقامة",
    "gov_sa.muqeem.settings.field.types.help": "مفاتيح أنواع المستندات، تفصل بينها فواصل.",
    "gov_sa.muqeem.settings.field.warning": "التنبيه قبل انتهاء الإقامة (أيام)",
    "gov_sa.nitaqat.establishment.counted_words": "{saudis_counted} · غير مواطنين {non_saudis}",
    "gov_sa.nitaqat.establishment.next_band_words": "{next_band} من {next_min_ratio}%",
    "gov_sa.nitaqat.establishment.ratio_words": "{ratio}%",
    "gov_sa.nitaqat.establishment_state.title": "نطاقات",
    "gov_sa.nitaqat.establishment_state.words": "{band} · {ratio}%",
    "gov_sa.nitaqat.establishment_tab.empty": "لم تُحسب نسبة بعد.",
    "gov_sa.nitaqat.settings.col.margin": "هامش التنبيه قبل حدّ النطاق",
    "gov_sa.nitaqat.settings.col.thresholds": "الحد الأدنى للأجر وحدود النطاقات",
    "gov_sa.nitaqat.settings.field.margin": "هامش التنبيه قبل حدّ النطاق (نقاط)",
    "gov_sa.nitaqat.settings.margin_words": "{margin} نقطة",
    "gov_sa.nitaqat.settings.thresholds.confirmed": "مؤكَّدة في شاشتيهما ⚠",
    "gov_sa.nitaqat.settings.thresholds.not_configured": "لم يُضبط شيء بعد — تُضبط في شاشتيهما ⚠",
    "gov_sa.nitaqat.settings.thresholds.unconfirmed": "بانتظار التأكيد في شاشتيهما ⚠",
    "gov_sa.qiwa.establishment.title": "قوى",
    "gov_sa.qiwa.establishment_channel.col.connected": "القناة",
    "gov_sa.qiwa.establishment_channel.connected.false": "القناة غير متصلة",
    "gov_sa.qiwa.establishment_channel.connected.true": "القناة متصلة",
    "gov_sa.qiwa.establishment_number.help": "كما تكتبه منصّة قوى، مثل 1-2345678. وحتى يُدخَل يُستعمل إعداد التشغيل.",
    "gov_sa.qiwa.establishment_number.title": "رقم المنشأة في قوى",
    "gov_sa.qiwa.establishment_tab.empty": "لا شيء ينتظر في قوى.",
    "gov_sa.qiwa.establishment_unattested.alert": "عقود لم تُوثَّق في قوى: {count}",
    "gov_sa.qiwa.establishment_unattested.title": "عقود لم تُوثَّق في قوى",
    "screen.mudad.establishment_record.title": "المنشأة",
    "unit.employees.few": "{n} موظّفين",
    "unit.employees.many": "{n} موظّفاً",
    "unit.employees.one": "موظّف واحد",
    "unit.employees.other": "{n} موظّف",
    "unit.employees.two": "موظّفان",
    "unit.employees.zero": "لا موظّفين",
    "value.decision.none": "لم يصدر بعد",
    "value.moved.joined": "انضمّ",
    "value.moved.left": "غادر",
    // مراجعة شاشات الموارد البشرية (2026-10-07).
    "screen.mudad.establishment.title": "بيانات المنشأة (مُدد)",
    "screen.mudad.run.title": "مسيّر الرواتب (حماية الأجور)",
};
//# sourceMappingURL=i18n-hr-lists.js.map